// Health permit urgency — shared by BookingsList morning briefing and
// BookingCard badge so both use identical logic.

const DAY_MS = 24 * 60 * 60 * 1000;

function tsToDate(v) {
  if (!v) return null;
  if (v.toDate) return v.toDate();
  if (v instanceof Date) return v;
  if (typeof v === "string" || typeof v === "number") return new Date(v);
  return null;
}

function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

// Count business days (Mon–Fri) between two dates, inclusive of neither endpoint
// (we want "days between now and the event"). Simple loop — the window we
// care about is always < 30 days.
function businessDaysUntil(now, eventDate) {
  const start = startOfDay(now);
  const end = startOfDay(eventDate);
  if (end <= start) return 0;
  let count = 0;
  const cur = new Date(start);
  while (cur < end) {
    cur.setDate(cur.getDate() + 1);
    const dow = cur.getDay();
    if (dow !== 0 && dow !== 6) count++;
  }
  return count;
}

/**
 * Returns the permit urgency state for a booking:
 *   "urgent"  — ≤ 2 business days out AND not paid
 *   "warning" — ≤ 7 days out AND not paid
 *   null      — no action needed (not applicable, already paid, or far out)
 */
export function permitUrgency(booking, now = new Date()) {
  if (!booking) return null;
  if (!booking.healthPermitNeeded) return null;
  if (booking.healthPermitStatus === "paid" || booking.healthPermitStatus === "not_needed") return null;
  if (booking.archivedAt) return null;

  const eventDate = tsToDate(booking.confirmedStart) || tsToDate(booking.confirmedDate) || tsToDate(booking.inquiryEventDate);
  if (!eventDate) return null;

  const today = startOfDay(now);
  if (eventDate < today) return null; // past — nothing to do

  const calendarDays = Math.floor((startOfDay(eventDate) - today) / DAY_MS);
  const businessDays = businessDaysUntil(now, eventDate);

  if (businessDays <= 2) return "urgent";
  if (calendarDays <= 7) return "warning";
  return null;
}
